import { action } from 'satcheljs/lib/legacy';
import { ComposeViewState } from 'owa-mail-compose-store';
import { findComposePlugins } from '../plugins/ComposePlugins';

export default action('preloadComposePlugins')(function preloadComposePlugins(
    viewState: ComposeViewState
) {
    const plugins = findComposePlugins(viewState);
    if (plugins) {
        if (
            plugins.mentionsPickerPlugin &&
            viewState.atMentions.atMentionTuples &&
            Object.keys(viewState.atMentions.atMentionTuples).length > 0
        ) {
            plugins.mentionsPickerPlugin.getPlugin();
        }

        if (plugins.praguePlugin) {
            plugins.praguePlugin.getPlugin();
        }
    }
});
